import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg width="26" height="27" viewBox="0 0 26 27" fill="none" {...props}>
      <rect x="3.84827" width="31.0678" height="5.44224" rx="2.72112" transform="rotate(45 3.84827 0)" fill="black" />
      <rect y="22.1553" width="31.0678" height="5.44224" rx="2.72112" transform="rotate(-45 0 22.1553)" fill="black" />
    </Svg>
  )
}

export default Icon
